import {Main} from '../components/main/main.tsx';
import {PageTitle} from '../components/page/page_title.tsx';
import {Page} from '../components/page/page.tsx';
import {PageContent} from '../components/page/page_content.tsx';
import {FlexRow} from '../components/utility/flex_row.tsx';
import {Alignment} from '../enums/alignment.ts';
import {Button} from '../components/button/button.tsx';
import {Header} from '../components/header/header.tsx';
import {transString} from '../support/lang/translations.ts';
import {FlexColumn} from '../components/utility/flex_column.tsx';
import {Spacer} from '../components/utility/spacer.tsx';

interface OwnProps {
    code?: number;
}

export function ErrorPage({code}: OwnProps) {
    return (
        <Main>
            <Header />
            <Page>
                <PageTitle>
                    <FlexColumn alignment={Alignment.Center}>
                        <FlexRow alignment={Alignment.Center}>
                            <h1>{code ?? ''}</h1>
                        </FlexRow>
                        <FlexRow alignment={Alignment.Center}>
                            <h2>{transString(`errors.${code}.title`)}</h2>
                        </FlexRow>
                    </FlexColumn>
                </PageTitle>
                <PageContent>
                    <FlexColumn alignment={Alignment.Center}>
                        <FlexRow alignment={Alignment.Center}>
                            <h3>{transString(`errors.${code}.description`)}</h3>
                        </FlexRow>
                        <FlexRow>
                            <Spacer style={{height: '3rem'}} />
                        </FlexRow>
                        <FlexRow alignment={Alignment.Center}>
                            <Button to={'/'}>
                                <i className="fa-light fa-house" />
                                Home
                            </Button>
                        </FlexRow>
                    </FlexColumn>
                </PageContent>
            </Page>
        </Main>
    );
}
